export class Integration {
	windowMessage(data){
		// console.log("message out", JSON.stringify(data));
		if(window.location.hostname !== 'localhost'){
			window.parent.postMessage(JSON.stringify(data), '*');
		}
	}

	parseBetSizes(){
		console.warn(`"parseBetSizes" not implemented`);
	}

	login(){
		console.warn(`"login" not implemented`);
	}

	initAnalytics(uid) {

	}

	postMixPanelEvent(eventName)
	 {
		var gameId = window.comm.r7Data.gameId || 'unknown_game';
		var playerId = window.comm.r7Data.playerId || 'unknown_playerId';
		var operator = "Ruby Seven"

		/* // window.location.hostname
		// "stage-mg1.deck-of-dice-games.net"
		let deployType = "unknown";
		if(window.location.hostname.indexOf('demo-') !== -1)
			deployType = "demo";
		else {
			const index = window.location.hostname.indexOf('-');
			if (index !== -1) 
				deployType = window.location.hostname.substring(0, index);
		} */
		const loc = window.location.hostname;
		const deployType = loc.includes('demo-') ? 'demo'
			: loc.includes('dod.rubyseven.com') ? 'r7prod'
			: loc.indexOf('-') > -1 ? loc.split('-')[0]
			: 'unknown';
		console.log("Mixpanel Event: ", eventName, " for game: ", gameId, " deploy: ", deployType, " playerId: ", playerId, " operator: ", operator);

		window.mixpanel.track(eventName,{
			"gameName": gameId,
			"deployType": deployType,
			"playerId": playerId,
			"operator": operator
			}
		);

	}

	postAnalyticsEvent(id, label, value, category) {
		// if(process.env.NODE_ENV === 'development' && window.location.hash !== '#sendanalytics'){
		// 	return;
		// }
		// var data = {};
		// data.event_label = label;
		// data.event_category = category || store.tutorialMode ? 'tutorial' : 'gameplay';
		// data.value = typeof value === 'number' ? value : 0;
		// console.log('gtag: ', id, data);
		// window.gtag('event', id, data);
	}

	onLoad(call){
		console.warn(`"onLoad" not implemented`);
	}
	onMatchStart(call){
		console.warn(`"onMatchStart" not implemented`);
	}
	onMatchResult(call){
		console.warn(`"onMatchResult" not implemented`);
	}
	onMatchEnd(call){
		console.warn(`"onMatchEnd" not implemented`);
	}
	onLowBalance(call){
		console.warn(`"onLowBalance" not implemented`);
	}
	onBetScreenReturn(){
		console.warn(`"onBetScreenReturn" not implemented`);
	}
	onError(call){
		console.warn(`"onError" not implemented`);
	}
	onShowFinalScorecard(call){
		console.warn(`"onShowFinalScorecard" not implemented`);
	}
	onTutorialOpen(call){
		console.warn(`"onTutorialOpen" not implemented`);
	}
	onTutorialStart(call){
		console.warn(`"onTutorialStart" not implemented`);
	}
	onTutorialAborted(call){
		console.warn(`"onTutorialAborted" not implemented`);
	}
	onTutorialSkipped(call){
		console.warn(`"onTutorialSkipped" not implemented`);
	}
	onTutorialCompleted(call){
		console.warn(`"onTutorialCompleted" not implemented`);
	}
}